import { api, getWithOptionalAuthorizationGeneric, putWithOptionalAuthorization } from './api';
import { TRIPPOIs_BASE, SECTION_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

export type RoutePOIsImage = {
  id: string;
  fileName: string;
  fileUrl: string;
  mobileFileUrl: string;
  description: string | null;
  fileSize: string;
  createdAt: string;
}

export type TripPOI = {
  id: string;
  routeID: string;
  mile: string;
  location: string;
  centreCoordinate: string[];
  markerPoint: string;
  poIsDetails: string;
  createdAt: string;
  updatedAt: string;
  summerDescription: string;
  winterDescription: string;
  sortOrder: number;
  routePOIsImageResponse: RoutePOIsImage[];
}


const trippoiApi = {

  getTripPOIByRouteId: async (routeID: string): Promise<TripPOI> => {
    try {
      const encryptedContestResponse = await getWithOptionalAuthorizationGeneric<TripPOI[]>
        (`${TRIPPOIs_BASE}/GetAll/${routeID}`, true);
      const getTripPOIResponse = await decryptMessage(encryptedContestResponse.data.Data, getToken());
      return getTripPOIResponse;
    } catch (error) {
      console.error('Error fetching trip pois by route Id:', error);
      throw error;
    }
  },

  saveReorderTripPOIs: async (payload: {
  }): Promise<any> => {
    try {
      const response = await putWithOptionalAuthorization(
        `${SECTION_BASE}/ReArrangeTripPOIs`,
        payload,
        true,
        false,
      );
      return response.data;
    } catch (error) {
      console.error("Error saving reordered Trip POIs:", error);
      console.log(error.response);
      throw error;
    }
  },


};

export default trippoiApi;